export default function utcNow() {
  var date = new Date();

  var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);

  return new Date(now_utc);
};
